import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { HouseKeepingService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { HouseKeeping } from '../../models'

const log = new Logger('HousekeepingDetailResolver')
@Injectable({ providedIn: 'root' })
export class HousekeepingDetailResolver
  implements Resolve<Observable<HouseKeeping>> {
  constructor(
    private housekeepingService: HouseKeepingService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['hid']
    
    return this.housekeepingService.getHouseKeepingDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/admin/housekeeping']))
    )
  }
}
